import { render } from "./GridOffsetIcon.vue?vue&type=template&id=f4528130"
import script from "./GridOffsetIcon.vue?vue&type=script&lang=js"
export * from "./GridOffsetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__